import { useAction } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { CrossIcon } from '@blade/ui-kit'
import { deleteRecentSearchAction } from '@root/features/user/recent-searches'

import { TOPBAR_BG_COLOR } from '../constants'
import { TopbarTrendingItem } from '../topbar-trending/topbar-trending-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  className?: string
}

export const TopbarRecentSearchItem = React.forwardRef<HTMLDivElement, Props>(
  ({ pair, className }, ref) => {
    const [isHovered, setIsHovered] = useState(false)
    const deleteRecentSearch = useAction(deleteRecentSearchAction)

    return (
      <Item
        ref={ref}
        className={className}
        onPointerEnter={() => setIsHovered(true)}
        onPointerLeave={() => setIsHovered(false)}
      >
        <TopbarTrendingItem pair={pair} />
        <AnimatePresence initial={false}>
          {isHovered ? (
            <motion.div
              layout
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 'auto', opacity: 1 }}
              exit={{ width: 0, opacity: 0 }}
              transition={{ ease: 'easeInOut' }}
              style={itemStyle}
            >
              <DeleteButton
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  deleteRecentSearch({
                    network: pair.base.network,
                    pairAddress: pair.address,
                  })
                }}
              >
                <CrossIcon size={12} />
              </DeleteButton>
            </motion.div>
          ) : undefined}
        </AnimatePresence>
      </Item>
    )
  },
)

const itemStyle = {
  overflow: 'hidden',
}

const Item = styled.div`
  background: ${TOPBAR_BG_COLOR};
  border-radius: 2px;
  padding: 0 5px;
  position: relative;
  display: flex;
  align-items: center;
`
const DeleteButton = styled.button`
  all: unset;
  color: var(--text-11);
  cursor: pointer;
  display: grid;
  margin-inline-start: 6px;

  &:hover {
    color: var(--appearance-inv-1);
  }
`
